// material
import { Container } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Edit from '../../components/countries/edit';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// components
import Page from '../../components/Page';
import { UserContext } from '../../contexts/UserContext';
// hooks
import useSettings from '../../hooks/useSettings';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

export default function EditCountry() {
  const { themeStretch } = useSettings();

  // Get locationId from path
  const params: any = useParams();
  const [id, setId] = useState<string>(params?.id);
  const [{ user }]: any = React.useContext(UserContext);

  return (
    <Page title="Edit country">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading="Edit country"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Countries', href: PATH_DASHBOARD.countries },
            { name: 'Edit country', href: PATH_DASHBOARD.countries }
          ]}
        />
        <Edit id={id} setId={(id: string) => setId(id)} disabled={!user.canEdit} />
      </Container>
    </Page>
  );
}
